import firebase from 'firebase/compat/app';

import 'firebase/compat/auth';
import 'firebase/compat/database';
import 'firebase/compat/firestore';
import 'firebase/compat/messaging';
import 'firebase/compat/storage';
import config from './constants';

// Inicializar Firebase
firebase.initializeApp(config.firebaseConfig);

// Servicios
const auth = firebase.auth();

// ── QA hook (safe by construction) ────────────────────────────────────────────
// Lets automated tests sign in with Firebase TEST phone numbers (no real SMS) by disabling the
// reCAPTCHA app-verifier — but ONLY on localhost, which is never publicly reachable, so there is no
// attack surface. EVERY other host (production AND staging) keeps full reCAPTCHA / SMS toll-fraud
// protection. Exact-match hostnames only — no substring/regex matching an attacker could satisfy.
export function qaBypassAllowed(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}
try {
  if (typeof window !== 'undefined' && qaBypassAllowed(window.location.hostname)) {
    auth.settings.appVerificationDisabledForTesting = true;
  }
} catch (e) { /* noop */ }
const firestore = firebase.firestore();
let db = firebase.database(); // Realtime Database
// FCM requires Service Workers — not available in WKWebView (iOS Facebook IAB)
let messaging = null;
if ('serviceWorker' in navigator) {
    try {
        messaging = firebase.messaging();
    } catch (e) {
        console.warn('Firebase Messaging not available:', e);
    }
}

const storage = firebase.storage();

auth.languageCode = 'en';

// Connect to emulators ONLY when running the dev project locally
// (`npm run serve`, projectId === 'kiey-dev-2'). For `npm run staging`
// or production builds — even on localhost — real Firebase services
// must be used. The previous always-on localhost hookup hijacked
// staging sessions and pointed auth/firestore at 127.0.0.1, which
// then failed because no emulator was running.
const isDevProject = config.firebaseConfig.projectId === 'kiey-dev-2';
if (config.useEmulators && isDevProject) {
    auth.useEmulator('http://localhost:9099');
    firestore.useEmulator('localhost', 8080);
    storage.useEmulator('localhost', 9199);
    db.useEmulator('localhost', 9000);
}

export { firebase, auth, firestore, db, messaging, storage };
